export default "__VITE_ASSET__DoXLrsqv__"